import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const root = createRoot(document.getElementById('root')!);
root.render(<React.StrictMode data-id="element-10">
    <App data-id="element-11" />
  </React.StrictMode>);